import { z } from "zod";
import { LIDAR_UPLOAD_STATUSES } from "./constants";

export const ProjectLidarUploadStatusSchema = z.object({
  region: z.string(),
  id: z.number(),
  name: z.string(),
  group_id: z.number().nullable(),
  group_name: z.string().nullable(),
  uploaded_file_count: z.number(),
  uploaded_file_source: z.enum(["database", "s3"]),
  raw_file_count: z.number(),
  raw_total_bytes: z.number(),
  airpelago_file_count: z.number(),
  airpelago_total_bytes: z.number(),
  airpelago_uploaded_at: z.string().nullable(),
  merged_file_count: z.number(),
  scene_count: z.number(),
  displayed_scene_count: z.number(),
  analysed_scene_count: z.number(),
  raw_uploaded_at: z.string().nullable(),
  merged_at: z.string().nullable(),
  displayed_at: z.string().nullable(),
  analysed_at: z.string().nullable(),
  status: z.enum(LIDAR_UPLOAD_STATUSES),
  status_reached_at: z.string().nullable(),
});

export type ProjectLidarUploadStatus = z.infer<
  typeof ProjectLidarUploadStatusSchema
>;

const MergeOptionSchema = z.object({ id: z.number(), name: z.string() });

export const LidarMergeOptionsSchema = z.object({
  clearance_systems: z.array(MergeOptionSchema),
  cfg_templates: z.array(MergeOptionSchema),
  default_cfg_template_id: z.number().nullable(),
});

export type LidarMergeOptions = z.infer<typeof LidarMergeOptionsSchema>;
